import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Dropdown from 'react-bootstrap/Dropdown';
import { RiMenu2Fill } from "react-icons/ri";

export default function Navbar() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navbarGradient = {
    background: "linear-gradient(to right, #f44336, #ffeb3b, #00e676, #2979ff)",
    color: "#000", // Makes text readable
    fontWeight: "500",
  };


  // Reusable NavLink with active class support for react-router-dom v6
  const NavItem = ({ to, children }) => (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `nav-links ${isActive ? 'active' : ''}`
      }
      onClick={handleClose}
    >
      {children}
    </NavLink>
  );

  return (
    <div>
      {/* Main Navbar */}
      <nav
        className="navbar navbar-expand-lg fixed-top"
        style={navbarGradient}
      >

        <div className="container-fluid">
          <div className="d-flex justify-content-center align-items-center">
            {/* Hamburger Menu Icon (Visible on mobile) */}
            <span
              onClick={handleShow}
              style={{ cursor: "pointer", color: "#000" }}
              className="me-4 d-lg-none" // 👈 hides on large screens and up
            >
              <RiMenu2Fill style={{ fontSize: 20 }} />
            </span>


            {/* Brand Logo/Title */}
            <div
              className="navbar-brand"
              onClick={() => navigate('/Home')}
              style={{ color: '#000', fontFamily: "Poppins", cursor: "pointer" }}
            >
              PADAMPURA JI
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav m-auto mb-2 mb-lg-0">
              {/* <li className="nav-item"><NavItem to="/Home">Home</NavItem></li> */}
              <li className="nav-item"><NavItem to="/Home">About</NavItem></li>
              <li className="nav-item"><NavItem to="/Facility">Facility</NavItem></li>
              <li className="nav-item dropdown">
                  <p className="mb-0 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dharamsala
                  </p>
                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div className="d-flex flex-column">
                    <NavItem to='/Dharmshala' class="dropdown-item" href="#">Dharmshalas</NavItem>
                    <NavItem to='/roomBooking' className="dropdown-item" href="#">Room Booking</NavItem>
                    </div>
                  </div>
              </li>

              <li className="nav-item"><NavItem to="/donatisons">Donations</NavItem></li>
              <li className="nav-item"><NavItem to="/Sadhvi">Guru</NavItem></li>
              <li className="nav-item"><NavItem to="/Events">Events</NavItem></li>
              <li className="nav-item"><NavItem to="/Contact">Contact</NavItem></li>

              {/* Committee Dropdown */}
              <li className="nav-item">
                <div style={{ zIndex: 10, position: 'relative' }}>
                  <Dropdown>
                    <Dropdown.Toggle className="nav-links border-0" variant="transparent" id="dropdown-basic">
                      Committee
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={handleClose}>
                        <NavLink
                          to="/OfficeBearer"
                          className={({ isActive }) => `nav-links p-0 ${isActive ? 'active' : ''}`}
                        >
                          Office Bearer
                        </NavLink>
                      </Dropdown.Item>
                      <Dropdown.Item onClick={handleClose}>
                        <NavLink
                          to="/ExecutiveMember"
                          className={({ isActive }) => `nav-links p-0 ${isActive ? 'active' : ''}`}
                        >
                          Executive Committee
                        </NavLink>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </li>
            </ul>

            {/* Login Link */}
            <ul className="navbar-nav">
              <li className="nav-item"><NavItem to="/AdminLogin">Login</NavItem></li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Offcanvas Sidebar (Mobile Menu) */}
      <Offcanvas show={show} onHide={handleClose} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ fontFamily: "Poppins", color: "#000" }}>
            PADAMPURA JI
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="navbar-nav mb-auto">
            {/* <li className="nav-item"><NavItem to="/Home">Home</NavItem></li> */}
            <li className="nav-item"><NavItem to="/Home">About</NavItem></li>
            <li className="nav-item"><NavItem to="/Dharmshala">Dharmshala</NavItem></li>
            <li className="nav-item"><NavItem to="/Sadhvi">Guru</NavItem></li>
            <li className="nav-item"><NavItem to="/Events">Events</NavItem></li>
            <li className="nav-item"><NavItem to="/Facility">Facility</NavItem></li>
            <li className="nav-item"><NavItem to="/Contact">Contact</NavItem></li>

            {/* Committee Dropdown in Sidebar */}
            <li className="nav-item ">
              <Dropdown>
                <Dropdown.Toggle className="nav-links " variant="transparent" id="dropdown-basic">
                  Committee
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleClose}>
                    <NavItem to="/OfficeBearer">Office Bearer</NavItem>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleClose}>
                    <NavItem to="/ExecutiveMember">Executive Committee</NavItem>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>

          {/* Login at bottom */}
          <ul className="navbar-nav">
            <li className="nav-item"><NavItem to="/AdminLogin">Login</NavItem></li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}